import React from 'react';
import backPageIcon from './backpage.svg';
import nextPageIcon from './nextpage.svg';
import styled from 'styled-components';
import { useAppDispatch } from 'store/hooks';
import { calendarSelectors } from 'services/selectors/apt';
import { aptUIActions } from 'services/reducers/apt';
import shopSelectors from 'services/selectors/shop';
import first from 'lodash/first';
import last from 'lodash/last';

const StaffPaging = () => {
  const dispatch = useAppDispatch();
  const currentPage = calendarSelectors.currentPage();
  const staffAvailable = shopSelectors.staffsAvailable();
  const nextPage = () => {
    const lastPage = last(staffAvailable)?.page;
    if (!lastPage) return;
    const nextPage = currentPage + 1;
    if (nextPage > lastPage) return;
    dispatch(aptUIActions.setCurrentPage(nextPage));
  };
  const backPage = () => {
    const firstPage = first(staffAvailable)?.page;
    if (!firstPage) return;
    const nextPage = currentPage - 1;
    if (nextPage < firstPage) return;
    dispatch(aptUIActions.setCurrentPage(nextPage));
  };

  return (
    <Container>
      <button onClick={backPage} type='button' className="btn"><img src={backPageIcon} alt="backPageIcon" style={{ width: 'auto', height: 35 }} /></button>
      <button onClick={nextPage} type='button' className="btn"><img src={nextPageIcon} alt="nextPageIcon" style={{ width: 'auto', height: 35 }} /></button>
    </Container>
  );
};

export default StaffPaging;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  button.btn {
    display: inline-flex;
    padding: 0px 8px;
    height: 48px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    background: #CCD4DC;
    box-shadow: 0 4px 8px -3px rgba(45, 35, 66, 0.30);
    &:active {
      opacity: 0.5;
    }
  }
`;
